// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CircleButton } = require('client-v2/common/components/buttons')
const SearchForm = require('client-v2/common/containers/search-form/component-smart')

const bem = BemEntity('LandingHeader')

class LandingHeader extends React.PureComponent {
  constructor(props) {
    super(props)
  }

  renderAuthSection() {
    return (
      tag('div', {
        className: bem.element('auth-section')
      },
        tag('button', {
          className: bem.element('auth-button', 'primary'),
          onClick: (
            this.props.isSULandingPage
              ? this.props.onSULoginClick
              : this.props.onSignupClick
          )
        },
          `Join Mix`
        ),
        tag('button', {
          className: bem.element('auth-button', 'secondary'),
          onClick: this.props.onLoginClick
        },
          `Sign in`
        )
      )
    )
  }

  renderBrandingSection() {
    return (
      tag('div', {
        className: bem.element('branding-section')
      },
        this.renderLogoContainer(),
        this.renderSearchContainer(),
        this.renderSearchButton()
      )
    )
  }

  renderLogoContainer() {
    return (
      tag('div', {
        className: bem.element('logo-container')
      },
        tag('div', {
          className: bem.element('logo-icon')
        }),
        tag('div', {
          className: bem.element('logo-text')
        })
      )
    )
  }

  renderSearchButton() {
    return (
      tag(CircleButton, {
        className: bem.element('search-button'),
        onClick: this.props.onSearchToggle
      })
    )
  }

  renderSearchContainer() {
    return (
      tag('div', {
        className: bem.element('search-container')
      },
        tag(SearchForm, {
          className: bem.element('search-form')
        })
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block({
          'scrolled-to-top': this.props.isScrolledToTop,
          'scrolled': this.props.isScrolledBelowFold ? 'down' : 'up',
          'searching': this.props.isSearchVisible
        })
      },
        this.renderBrandingSection(),
        this.renderAuthSection()
      )
    )
  }
}

LandingHeader.propTypes = {
  // Flags
  isScrolledToTop: PropTypes.bool.isRequired,
  isScrolledBelowFold: PropTypes.bool.isRequired,
  isSULandingPage: PropTypes.bool.isRequired,
  isSearchVisible: PropTypes.bool.isRequired,
  // Callbacks
  onLoginClick: PropTypes.func.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  onSULoginClick: PropTypes.func.isRequired,
  onSearchToggle: PropTypes.func.isRequired
}

module.exports = LandingHeader
